<template>
  <div class="hot-item">
    {{item}}
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: String
    }
  }
};
</script>
<style lang="scss" scoped>
.hot-item {
  display: inline-block;
  padding: 4px 0;
  font-size: 14px;
  color: #747990;
  cursor: pointer;
  &:hover {
    color: #0750E0;
    font-weight: bold;
  }
}
</style>
